/* eslint-disable @typescript-eslint/no-explicit-any */
import { ScopeProviderWithInitializer } from 'components/scope-provider'
import { getProductBySymbol } from 'indices-list'
import type React from 'react'
import { Suspense } from 'react'
import { useParams } from 'react-router'
import { Navigate } from 'react-router-dom'
import Path from 'router'

import ProductLoading from './loading'
import { ProductPage } from './product'
import { createProductStorageAtoms } from './storage'
import { PageWrapper } from './styled'

export const IndexDetailsPage: React.FC = (): JSX.Element => {
  const { symbol } = useParams<{ symbol: string }>()
  const product = getProductBySymbol(symbol ?? '')

  if (!symbol || !product) {
    return <Navigate to={Path.MAIN} />
  }

  return (
    <PageWrapper>
      <ScopeProviderWithInitializer atomValues={createProductStorageAtoms(product)} key={symbol}>
        <Suspense fallback={<ProductLoading product={product} />}>
          <ProductPage product={product} />
        </Suspense>
      </ScopeProviderWithInitializer>
    </PageWrapper>
  )
}
